<template>
    <div class="user-page" ref="tree">
        <el-container class="self-container">
            <el-aside class="self-aside">
                <Evtree :defaultProps="props"  ref="menuTree" node-key="id" class="treesbox"
                        :expandedKeys="['0']" :default-expanded-keys="[0]" :default-expand-all="true" :accordion="true"
                        :load="loadNode" lazy :width="290"
                        @treeNodeclick="treeNodeclick" placeholder="输入组织机构名称进行过滤"></Evtree>
            </el-aside>
            <el-main class="self-main">
                <Evtable :header="tableHeader" :params="paramsUrl"
                         :quickSearchKey="quickSearchKey" :quickSearchReg="quickSearchReg"
                         :quickSearchPlaceholder="quickSearchPlaceholder"
                         searchDialogWidth="50%"
                         :searchRules="searchRules"
                         :searchData="searchDatas" actionWidth="120"
                         :tools="tools" :actions="action" url="/wtcp-oauth/users/page">
                    <template slot="searchForm" class="search-box">
                        <el-col :span="12">
                            <el-form-item label="登录账号" prop="username" label-width="80px">
                                <el-input maxlength="30" v-model.trim="searchDatas.username" placeholder="请输入登录账号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="name" label-width="80px">
                                <el-input maxlength="50" v-model.trim="searchDatas.name" placeholder="请输入姓名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="昵称" prop="nickname" label-width="80px">
                                <el-input maxlength="30" v-model.trim="searchDatas.nickname" placeholder="请输入昵称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话" prop="phone" label-width="80px">
                                <el-input maxlength="11" v-model.trim="searchDatas.phone" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="账号状态" prop="status" label-width="80px">
                                <el-radio-group v-model="searchDatas.status">
                                    <el-radio label="1">开通</el-radio>
                                    <el-radio label="2">关闭</el-radio>
                                    <el-radio label="3">锁定</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="管理员" prop="isAdmin" label-width="80px">
                                <el-radio-group v-model="searchDatas.isAdmin">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="0">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </template>
                </Evtable>
            </el-main>
        </el-container>
        <!-- 弹层 -->
        <el-dialog class="dialog" title="关联角色" :visible.sync="dialogVisible" width="800px"
                   ref="clears">
            <el-form :model="roleModel" ref="role" label-width="100px">
                <el-form-item label="关联角色">
                    <el-select style="width: 100%" v-model="userRole" multiple placeholder="请选择要关联的角色">
                        <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="text-align: center">
                    <el-button type="primary" @click="submitForm">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import Treeselect from "@riophae/vue-treeselect";
    import "@riophae/vue-treeselect/dist/vue-treeselect.css";
    import ElInput from "element-ui/packages/input/src/input";
    import ElInputNumber from "element-ui/packages/input-number/src/input-number";
    import ElButton from "element-ui/packages/button/src/button";
    import ElTree from "element-ui/packages/tree/src/tree";

    export default {
        components: { ElTree, ElButton, ElInputNumber, ElInput, Treeselect},
        data() {
            let _this = this;
            return {
                paramsUrl: {},
                quickSearchKey: "complexName",
                quickSearchReg: /[%]|[_]|[*]/,
                quickSearchPlaceholder: "输入账号或姓名或昵称",
                // 工具栏
                tools: [{
                    name: 'byhgl:c',
                    click: function () {
                        _this.$router.push({
                            name: 'wtcp-auths-byhgl-form',
                            query: {
                                id: -1,
                            }
                        })
                    }
                }],
                // 列表数据
                tableHeader: [
                    {
                        type: 'extend',
                        label: '',
                        width: "35",
                        extend: function (e) {
                            const nickname = e.nickname ? e.nickname : '暂无数据';
                            let sex = "暂无数据";
                            if(e.sex == 1){
                                sex = '男';
                            }else if(e.sex == 2){
                                sex = '女';
                            }else if(e.sex == 3){
                                sex = '其他';
                            }
                            const birthday = e.birthday ? e.birthday : "暂无数据";
                            return '<div class="extend-box">' +
                                '<span>昵称：'+ nickname +'</span>' +
                                '<span>性别：'+ sex +'</span>' +
                                '<span>生日：'+ birthday +'</span>' +
                                '</div>';
                        }
                    },{
                            label: "登录账号",
                            prop: "username"
                    },{
                            label: "姓名",
                            prop: "name"
                    },{
                            label: "手机号",
                            prop: "phone",
                            align: "center",
                            width: "100"
                    },{
                            label: "所属机构",
                            prop: "deptName"
                    }, {
                            type: "color",
                            label: "数据权限",
                            align: "center",
                            prop: "dsType",
                            width: "90",
                            color: function (h) {
                                if (h.dsType === 1) {
                                    return '#67c23a';
                                } else if (h.dsType === 2) {
                                    return 'red';
                                } else if (h.dsType === 3) {
                                    return 'orange';
                                } else if (h.dsType === 4) {
                                    return '#00b8ff';
                                }
                            },
                            formatter: function (h) {
                                if(h.dsType == 1){
                                    return '全部';
                                }else if(h.dsType == 2){
                                    return '本级及子级';
                                }else if(h.dsType == 3){
                                    return '本级';
                                }else if(h.dsType == 4){
                                    return '自定义';
                                }
                            }
                    }, {
                            type: "icon",
                            label: "管理员",
                            align: "center",
                            prop: "isAdmin",
                            width: "60",
                            icon: function (h) {
                                if(h.isAdmin == 1){
                                    return 'fas fa-check';
                                }else {
                                    return 'fas fa-times';
                                }
                            },
                            color: function (h) {
                                if (h.isAdmin == 0) {
                                    return 'red';
                                } else if (h.isAdmin == 1) {
                                    return '#67c23a';
                                }
                            }
                    }, {
                            type: "color",
                            label: "状态",
                            align: "center",
                            prop: "status",
                            width: "55",
                            color: function (h) {
                                if (h.status === 1) {
                                    return '#67c23a';
                                } else if (h.status === 2) {
                                    return 'red';
                                } else if (h.status === 3) {
                                    return 'orange';
                                }
                            },
                            formatter: function (h) {
                                if(h.status == 1){
                                    return '开通';
                                }else if(h.status == 2){
                                    return '关闭';
                                }else if(h.status == 3){
                                    return '锁定';
                                }
                            }
                    }
                ],
                // 操作
                action: [
                    {
                        name: "byhgl:a",
                        click: function (e, refesh) {
                            _this.showDialog(e.id);
                        },
                        disabled: function (e, oprah) {
                            let userName = _this.request.getSession('userInfo').username;
                            let dsType = _this.request.getSession('userInfo').dsType;
                            if(dsType == 1 || dsType == '1'){
                                return (e.username == userName)? true:false;
                            }else{
                                return e.username == userName || e.createdUser != userName;
                            }
                        }
                    },
                    {
                        name: 'byhgl:u',
                        click: function (e) {
                            _this.opt.editRow(e, _this, 'wtcp-auths-byhgl-form', {
                                id: e.id
                            });
                        },
                        disabled: function (e, oprah) {
                            let userName = _this.request.getSession('userInfo').username;
                            let dsType = _this.request.getSession('userInfo').dsType;
                            if(dsType == 1 || dsType == '1'){
                                return (e.username == userName)? true:false;
                            }else{
                                return e.username == userName || e.createdUser != userName;
                            }
                        }
                    },
                    {
                        name: 'byhgl:x',
                        click: function (e) {
                            _this.$confirm("确认要重置用户【"+e.username+"】的密码吗?", "提示", {
                                confirmButtonText: "确定",
                                cancelButtonText: "取消",
                                type: "warning"
                            }).then(() => {
                                _this.request.get("/wtcp-oauth/users/resetPwd", {username: e.username}).then(res => {
                                    if (res.status === 1) {
                                        _this.$message.success("重置密码成功");
                                    } else {
                                        _this.$message.error(res.msg);
                                    }
                                });
                            })
                        },
                        disabled: function (e, oprah) {
                            let userName = _this.request.getSession('userInfo').username;
                            return !(userName == 'admin');
                        }
                    },
                    {
                        name: 'byhgl:d',
                        click: function (e, refresh) {
                            _this.deleteUser(e.id, refresh);
                        }
                    }
                ],
                searchRules: {},
                searchDatas: {
                    username: '',
                    name: '',
                    nickname: '',
                    status: null,
                    phone: '',
                    isAdmin: null
                },
                options: [],
                dialogVisible: false,
                roleModel: null,
                userRole: null,
                userId: -1,
                pageload: false,
                maxLevel: "5",
                props: {
                    label: 'name',
                    children: 'children',
                    isLeaf: 'isLeaf'
                },
                treeData: [{
                    label: "组织机构",
                    expand: false,
                    id: "0",
                    level: 0,
                    name: "组织机构",
                    title: "组织机构",
                    children: []
                }],
            };
        },
        methods: {
            loadNode(node, resolve) {
                if (node.level === 0) {
                    node.data.id = 0;
                    this.getIndex(node, resolve);
                }else {
                    this.getIndex(node, resolve);
                }
            },

            // 异步加载叶子节点数据函数
            getIndex(node, resolve) {
                let that = this;
                that.request.get("/wtcp-oauth/dept/noRightTree", {pid: node.data.id}).then(res => {
                    if (res.status === 1) {
                        let data = res.data;
                        if(node.level === 0){
                            that.treeData[0].children = data;
                            resolve(that.treeData);
                        }else {
                            resolve(data);
                        }
                    } else {
                        that.$message.error(res.msg);
                    }
                });
            },
            getAllRole(){
                let that = this;
                that.request.get("/wtcp-oauth/role/findByUsername")
                    .then(res => {
                        if (res.status === 1) {
                            that.options = res.data;
                        } else {
                            that.$message.error(res.msg);
                        }
                    });
            },
            showDialog(id){
                let that = this;
                that.userId = id;
                that.userRole = null;
                that.dialogVisible = true;
                that.request.get("/wtcp-oauth/users/getUserRole/"+id)
                    .then(res => {
                        if (res.status === 1) {
                            let role = res.data;
                            let jrole = [];
                            for(let i=0; i<role.length; i++){
                                let r=role[i].roleId;
                                jrole.push(r);
                            }
                            that.userRole = jrole;
                        } else {
                            that.$message.error(res.msg);
                        }
                    });
            },
            submitForm(){
                if(this.userRole.length > 0){
                    let role = "";
                    for(let i=0; i<this.userRole.length; i++){
                        role += this.userRole[i]+",";
                    }
                    role = role.substr(0,role.length-1);
                    this.request.get("/wtcp-oauth/users/editUserRole/"+this.userId, {role: role}).then(res => {
                        if (res.status === 1) {
                            this.dialogVisible = false;
                            this.$message.success(res.msg);
                        } else {
                            this.dialogVisible = false;
                            this.$message.error(res.msg);
                        }
                    });
                }
            },
            refresh(e) {
                this.refreshMenu = e;
            },
            deleteUser(id, refresh){
                let that = this;
                that.$confirm("确认要删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    that.request.delete("/wtcp-oauth/users", id).then(res => {
                        if (res.status === 1) {
                            that.$message({message: "删除成功", type: "success"});
                            refresh();
                            that.getMenuTreeData();
                        } else {
                            that.$message.error(res.msg)
                        }
                    });
                })
            },
            /**
             * 获取组织机构数据 linjw 2019年7月5日09:37:49
             */
            getAllTreeData() {
                let that = this;
                that.request
                    .get("/wtcp-oauth/dept/noRightTree", {
                        pid: 0
                    })
                    .then(res => {
                        if (res.status === 1) {
                            const child = that.getsorl(res.data, that.maxLevel);
                            that.treeData[0].children = child;

                        } else {
                            that.$message.error(res.msg);
                        }
                    });
            },
            //树形结构添加排序值
            getsorl(data, foolr) {
                for (var i in data) {
                    if (data[i].level === foolr) {
                        data[i].title = data[i].name;
                        data[i].label = data[i].name;
                    } else {
                        this.getsorl(data[i].children, foolr);
                        data[i].title = data[i].name;
                        data[i].label = data[i].name;
                    }
                }
                return data;
            },
            treeNodeclick(node, data) {
                if(node.data.id == 0){
                    this.paramsUrl = {}
                }else{
                    this.paramsUrl = {
                        deptId: data.id
                    }
                }
            }
        },
        watch: {
            paramsUrl() {
                return this.paramsUrl
            }
        },
        created() {
            this.request.oprahfun(this);
            this.getAllRole();
            this.getAllTreeData();
        },
        mounted() {
            let $clMain = document.getElementsByClassName("cl-main")[0],
                $treeBox = $clMain.getElementsByClassName("el-tree")[0],
                $clMainH = $clMain.offsetHeight;
            $treeBox.style.height = ($clMainH - 80) + "px";
            $treeBox.style.overflow = "hidden";
            $treeBox.style["overflow-y"] = "scroll";
        }
    }
    ;
</script>
<style lang="less">
    .user-page {
        .search-box {
            .el-radio {
                margin-right: 15px;
            }
        }

        position: relative;
        .extend-box{
            height: 35px;
            line-height: 35px;
            span {
                margin-left: 30px;
                display: inline-block;
                width: 25%;
                white-space:nowrap;
                text-overflow:ellipsis;
                overflow:hidden;
            }
        }

        width: 100%;

        .custom-tree-container {
            overflow: unset;
            height: 100%;
            position: relative;
            z-index: 1;
            float: left;
        }

        .treesbox > .el-input {
            margin-bottom: 10px;
        }

        .treesbox .el-tree.el-tree--highlight-current {
            /*border-right: #dcdfe6 solid 1px !important;*/
            overflow-x: hidden !important;;
            overflow-y: auto !important;;
        }
        /*.treesbox{*/
        /*    position: absolute;*/
        /*}*/

    }
</style>
